import { Component, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';
import { isString } from 'class-validator';
import { getConfig, getCurrentUser } from 'src/app/core/services/functions.service';
import { MenuService, OpcionMenu } from 'src/app/core/services/menu.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent {

  constructor(private router: Router, private menuService: MenuService) {

    //Comprobamos si la ruta actual hace match con las opciones a las que tiene permiso, exeptuando /admin/dashboard y /home
    //Solo comprobaremos esto en producción
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let isForbidden = false
        if (environment.production && getCurrentUser().usuario_aplicativo != "SADMIN") {
          const href = this.router.routerState.snapshot.url
          console.log(href)
          if (!["/admin/dashboard", "/home"].includes(href)) {
            const modules = this.menuService.getModules()
            if (modules.length == 0) isForbidden = false
            const foundModulo = modules.find(element => {
              if (element.opciones && element.opciones.length) {
                return this.checkOptions(element.opciones, href)
              }
              isForbidden = true
            });
            isForbidden = foundModulo ? false : true
          }
          if (href.includes('events/detail-event')) {
            isForbidden = false;
          }
        }
        if (isForbidden) {
          this.router.navigate([getConfig("route_on_forbidden")])
        }
      }
    });
  }

  checkOptions(options: OpcionMenu[], href: string) {
    if (isString(options)) {
      return false
    }
    const find = options.find(op => {
      if (op.rutas && op.rutas.length) {
        return this.checkOptions(op.rutas, href)
      } else if (op.ruta) {
        return href.includes(op.ruta)
      }
      return false
    })
    return find ? true : false
  }
}
